/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AppendContactsCompanyRequest
 */
export interface AppendContactsCompanyRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof AppendContactsCompanyRequest
   */
  contactIds?: Array<string>
}

export function AppendContactsCompanyRequestFromJSON(json: any): AppendContactsCompanyRequest {
  return AppendContactsCompanyRequestFromJSONTyped(json, false)
}

export function AppendContactsCompanyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendContactsCompanyRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactIds: !exists(json, 'contact_ids') ? undefined : json['contact_ids']
  }
}

export function AppendContactsCompanyRequestToJSON(value?: AppendContactsCompanyRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_ids: value.contactIds
  }
}
